import { render, staticRenderFns } from "./VowelsTest.vue?vue&type=template&id=17b27984&scoped=true&"
import script from "./VowelsTest.vue?vue&type=script&lang=js&"
export * from "./VowelsTest.vue?vue&type=script&lang=js&"
import style0 from "./VowelsTest.vue?vue&type=style&index=0&id=17b27984&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b27984",
  null
  
)

export default component.exports